import { CircularProgress } from "@mui/material";
import { Container } from "./styles";
import React from "react";
import { createPortal } from "react-dom";
import { ReactComponent as LogoIcon } from "../../assets/a-logo.svg";

export const Loading = () => {
  return createPortal(
    <Container>
      <LogoIcon width={300} height={100} />
      <CircularProgress />
    </Container>,
    document.body
  );
};
